<template>
  <div>
    <report-panel :anchor="''">
      <div slot="title">Company Descriptions</div>
      <div slot="body">
        <!-- panel content start -->
        <table class="table table-striped" id="company-description-table">
          <tbody>
            <tr>
              <th scope="row">Description:</th>
              <td>
                <ul class="list-group">
                  <span
                    v-for="description in report.companyoverview.descriptions"
                    :key="description.id"
                  >
                    <li class="list-group-item">
                      {{ description.text }}
                      <br />
                      <strong v-if="description.source"> (Source: {{ description.source }}) </strong>
                    </li>
                  </span>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope="row">Keywords:</th>
              <td>
                <template v-if="report.companyoverview.keywords.length > 0">
                  <ul class="list-inline">
                    <li v-for="keyword in report.companyoverview.keywords" :key="keyword.id">
                      {{ keyword.keyword }}
                    </li>
                  </ul>
                  <em v-if="report.companyoverview.keywords.length > 1"> Ordered by relevance </em>
                </template>
                <template v-else>
                  <em>Not available</em>
                </template>
              </td>
            </tr>
            <tr>
              <th scope="row">2007 SIC:</th>
              <td>
                <ul class="list-group">
                  <span v-for="sic2007 in report.companyoverview.sic_code2007s" :key="sic2007.id">
                    <li class="list-group-item">
                      <strong>{{ sic2007.code }}: </strong>{{ sic2007.name }}
                    </li>
                  </span>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope="row">2003 SIC:</th>
              <td>
                <ul class="list-group">
                  <span v-for="sic2003 in report.companyoverview.sic_code2003s" :key="sic2003.id">
                    <li class="list-group-item">
                      <strong>{{ sic2003.code }}: </strong>{{ sic2003.name }}
                    </li>
                  </span>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- panel content end -->
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>
